import { gql } from "@apollo/client";

export default gql`
  query employerExists($email: String!) {
    employerExists(email: $email)
  }
`;
